<ng-container *ngIf="isLoading else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>
<div class="container-fluid member-section p-4 rounded-4 mt-4">
  <h4 class="section-heading mb-4">
    <i class="bi bi-people me-2"></i>Class Members
  </h4>

  <!-- Teacher Invite Section -->
  <div class="d-flex justify-content-between align-items-center mb-3 position-relative">
    <h5 class="role-title">Teachers</h5>
    <div class="position-relative" #teacherContainer>
      <!-- for now we have to comment this , will used this later
		<button class="btn-invite"  (click)="toggleTeacherInvite()">
        <i class="bi bi-person-plus me-1"></i> Invite
      </button>

      <div #teacherPopup class="invite-popup-wrapper-inline mt-2" *ngIf="showInvite">
        <div class="invite-popup card p-4 shadow">
          <h5 class="fw-bold mb-3">Invite Teacher</h5>
          <input
            type="email"
            class="form-control custom-input mb-2"
            placeholder="Enter teacher email"
            [(ngModel)]="inviteEmail"
            [class.is-invalid]="emailError"
          />
          <div class="invalid-feedback" *ngIf="emailError">
            Please enter a valid email address.
          </div>
          <div class="d-flex justify-content-between mt-3">
            <button class="btn btn-success d-flex align-items-center px-4" (click)="sendInvite()" [disabled]="isSending">
			<ng-container *ngIf="!isSending; else noSending">
              <i class="bi bi-person-plus me-2"></i> Send</ng-container>
			  <ng-template #noSending>
			<span class="spinner-text">
			<mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>Sending...</span>
			</ng-template>
            </button>
            <button class="btn-cancel px-4" (click)="cancelInvite()">Cancel</button>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <!-- Teacher List -->
  <div class="row mb-4">
		<ng-container *ngIf="_teachers.length > 0 ; else noTeachers">
    <div class="list col-md-6 mb-3"
	*ngFor="let teacher of _teachers">
      <div class="member-card d-flex align-items-center p-3">
        <div class="avatar-box me-3">{{teacher.first_name[0]}}{{teacher.last_name[0]}}</div>
        <div class="flex-grow-1">
          <strong class="member-name">{{teacher.first_name}} {{teacher.last_name}}</strong>
          <div class="member-email">{{teacher.phone_email}}</div>
        </div>
		  <ng-container *ngIf="teacher.owner; else teacherLabel">
        <span class="badge role-badge owner-badge">Owner</span>
		</ng-container>
		 <ng-template #teacherLabel>
			<img src="assets/images/member.png" class="img-fluid me-2" alt="member-icon"
			(click)="openDeleteMemberDialogBox(usersRolesTeacher.CoTeacher, teacher.user_id)">
		<span class="badge role-badge owner-badge">Teacher</span>
		 </ng-template>
      </div>
    </div>
	</ng-container>
	<ng-template #noTeachers>No Teachers available</ng-template>

  <!-- Student Invite Section -->
  <div class="d-flex justify-content-between align-items-center mb-3 position-relative">
    <h5 class="role-title">Students</h5>
    <div class="position-relative" #studentContainer>
      <button class="btn-invite"(click)="toggleStudentInvite()">
        <i class="bi bi-person-plus me-1"></i> Invite
      </button>

      <div #studentPopup class="inline-invite-popup mt-2" *ngIf="showStudentInvite">
        <h5 class="fw-bold mb-3">Invite Student</h5>
        <input
          type="email"
          class="form-control custom-input mb-2"
          placeholder="Enter student email"
          [(ngModel)]="studentInviteEmail"
          [class.is-invalid]="studentEmailError"
        />
        <div class="invalid-feedback" *ngIf="studentEmailError">
          Please enter a valid email address.
        </div>
        <div class="d-flex justify-content-between mt-3">
          <button class="btn btn-gradient px-4" (click)="sendStudentInvite()" [disabled]="isSending">
			<ng-container *ngIf="!isSending; else noSending">
            <i class="bi bi-envelope me-2"></i> Send</ng-container>
			<ng-template #noSending>
			<span class="spinner-text">
			<mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>Sending...</span>
			</ng-template>
          </button>
          <button class="btn-cancel px-4" (click)="cancelStudentInvite()">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Student List -->
  <div class="row">
	<ng-container *ngIf="_students.length > 0 ; else noStudents">
    <div class=" list col-md-6 mb-3" *ngFor="let student of _students">
      <div class="member-card d-flex align-items-center p-3">
        <div class="avatar-box me-3">{{student.first_name[0]}}{{student.last_name[0]}}</div>
        <div class="flex-grow-1">
          <strong class="member-name">{{student.first_name}} {{student.last_name}}</strong>
          <div class="member-email">{{student.phone_email}}</div>
        </div>
			<img src="assets/images/member.png" class="img-fluid me-2" alt="member-icon"
			(click)="openDeleteMemberDialogBox(usersRolesTeacher.Student,student.user_id)">
        <span class="badge role-badge student-badge">Student</span>
      </div>
    </div>
	</ng-container>
	<ng-template #noStudents>No student are available</ng-template>
  </div>
</div>
</div>
</ng-template>